import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IStore } from '@/redux/defaultStore';
import { decrementModalCount } from '@/redux/meta/metaActions';
import GoVipSpin2WinModal from '@/components/modals/GoVipSpin2WinModal';
import { getDateInEst } from '@/utils/getDateInEst';
import styles from './ActionIcons.module.scss';

const ActionIcons: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSpinModal, setShowSpinModal] = useState(false);
  const [spinAvailable, setSpinAvailable] = useState(false);
  const currentUser = useSelector((store: IStore) => store.metaStore.currentUser);
  const dispatch = useDispatch();

  // Check if spin is available based on lastSpin date
  useEffect(() => {
    if (currentUser?.user) {
      const lastSpinDate = currentUser.user.lastSpin
        ? getDateInEst(new Date(currentUser.user.lastSpin))
        : null;

      const currentDate = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
      const startOfToday = new Date(currentDate);
      startOfToday.setHours(0, 0, 0, 0);

      const canSpin = !lastSpinDate || lastSpinDate < startOfToday;
      setSpinAvailable(canSpin);
    }
  }, [currentUser?.user?.lastSpin]);

  const toggleSpinModal = () => {
    const wasOpen = showSpinModal;
    setShowSpinModal(!showSpinModal);

    if (wasOpen) {
      dispatch(decrementModalCount());
    }
  };

  const handleWheelClick = () => {
    if (!currentUser) {
      // Not authenticated - could show login modal
      return;
    }
    setShowSpinModal(true);
  };

  const handleLootShopClick = () => {
    navigate('/play?view=lootshop', { replace: false });
  };

  const handleLootBoxClick = () => {
    navigate('/play?view=lootbox', { replace: false });
  };

  const handleStashClick = () => {
    navigate('/play?view=collectibles', { replace: false });
  };

  return (
    <>
      <div className={styles.actionIcons}>
        <button
          className={`${styles.iconButton} ${!spinAvailable ? styles.disabled : ''}`}
          onClick={spinAvailable ? handleWheelClick : undefined}
          title={spinAvailable ? "Daily Spin Available" : "Come back tomorrow"}
          disabled={!spinAvailable}
        >
          <img
            src="/images/wheelspin-icon.png"
            alt="Spin the Wheel"
            className={styles.icon}
          />
          <span className={styles.label}>Spin</span>
        </button>

        <button
          className={styles.iconButton}
          onClick={handleLootShopClick}
          title="LootShop"
        >
          <img
            src="/images/lootshop-icon.png"
            alt="LootShop"
            className={styles.icon}
          />
          <span className={styles.label}>LootShop</span>
        </button>

        <button
          className={styles.iconButton}
          onClick={handleLootBoxClick}
          title="LootBoxes"
        >
          <img
            src="/images/lootboxes-icon.png"
            alt="LootBoxes"
            className={styles.icon}
          />
          <span className={styles.label}>LootBoxes</span>
        </button>

        <button
          className={styles.iconButton}
          onClick={handleStashClick}
          title="My Stash"
        >
          <img
            src="/images/collectibles-icon.png"
            alt="My Stash"
            className={styles.icon}
          />
          <span className={styles.label}>Stash</span>
        </button>
      </div>

      {/* Spin Modal */}
      <GoVipSpin2WinModal
        isOpen={showSpinModal}
        toggle={toggleSpinModal}
      />
    </>
  );
};

export default ActionIcons;